import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserUtils } from '@azure/msal-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// MSAL popup/iframe token renewals land here with #code=…. Booting the app would
// strip the hash before the opener reads it, so leave the static splash in place.
const isAuthResponse = /[#?&](code|error)=/.test(location.hash + location.search);
if (!(isAuthResponse && (BrowserUtils.isInPopup() || BrowserUtils.isInIframe()))) {
  bootstrapApplication(App, appConfig)
    .catch((err) => console.error(err));
}
